import * as THREE from 'three'

const AVATAR_PREVIEW_CONFIG = {
  lights: {
    ambient: {
      intensity: 2,
    },
    point: {
      position: [2, 2, 2] as [number, number, number],
      intensity: 1.2,
    },
    directional: {
      position: [1, 1, 1] as [number, number, number],
      intensity: 1.2,
    },
    fill: {
      position: [0, 3, 0] as [number, number, number],
      intensity: 10,
    },
  },
}

export const setupLights = (scene: THREE.Scene) => {
  // Ambient light
  const ambientLight = new THREE.AmbientLight(
    0xffffff,
    AVATAR_PREVIEW_CONFIG.lights.ambient.intensity,
  )
  scene.add(ambientLight)

  // Directional light
  const directionalLight = new THREE.DirectionalLight(
    0xffffff,
    AVATAR_PREVIEW_CONFIG.lights.directional.intensity,
  )
  directionalLight.position.set(
    ...AVATAR_PREVIEW_CONFIG.lights.directional.position,
  )
  directionalLight.castShadow = true
  directionalLight.shadow.mapSize.width = 2048
  directionalLight.shadow.mapSize.height = 2048
  directionalLight.shadow.camera.near = 0.1
  directionalLight.shadow.camera.far = 50
  scene.add(directionalLight)
}
